import NoteComment from '~/scripts/services/model/note-comment';
import Repre from '~/scripts/services/model/repre';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import { Confirm } from '~/scripts/services/modal/modal';

/* globals Knitiv */

export default class NoteCommentController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} User
	 */
	constructor(
		$injector,
		$rootScope,
		$translate,
		User,
	) {
		this.$injector = $injector;
		this.$rootScope = $rootScope;
		this.$translate = $translate;
		this.User = User;

		this.disabled = false;

		/** @type {NoteComment} */
		this.comment = new NoteComment();

		/** @type {?import('../comments.controller').default} */
		this.commentsCtrl = null;

		/** @type {?import('../note-context/note-context.controller').default} */
		this.noteContextCtrl = null;

		/** @type {?Function} */
		this.onDelete = null;

		/** @type {?Function} */
		this.onSubmit = null;

		/** @type {?NoteCommentController} */
		this.parent = null;
	}

	cancel() {
		if (this.comment.isReply()) {
			if (typeof this.onDelete === 'function') {
				this.onDelete();
			}
		}
		else {
			this.comment.cancel();
		}
	}

	check() {
		const context = this.noteContextCtrl?.ctx.kid
			? this.noteContextCtrl.ctx : this.noteContextCtrl?.tmpContext;

		const isFilledContent = this.comment.content && this.comment.content !== '<p></p>';

		return isFilledContent && context?.type && this.comment.type;
	}

	async delete() {
		const modal = new Confirm(this.$injector);
		const answer = await modal.open({
			title:  this.$translate.instant('notes.confirm-delete-note-title'),
			body:   `<p>${this.$translate.instant('notes.confirm-delete-note-message')}</p>`,
			cancel: {
				label: this.$translate.instant('common.cancel'),
				type:  'default',
			},
			accept: {
				label: this.$translate.instant('common.delete'),
				type:  'danger',
			},
		});

		if (answer) {
			const result = await this.noteContextCtrl?.NodeService.delete(this.comment.kid);
			if (result && typeof this.onDelete === 'function') {
				this.onDelete();
			}
		}
	}

	/**
	 * @param {NoteComment} comment
	 */
	reply(comment) {
		if (this.$rootScope.context?.profil.kid && this.$rootScope.context?.profil.name) {
			const replyNote = new NoteComment({
				author: this.$rootScope.context?.profil.kid,
				parent: comment,
			});
			replyNote.reply();
			this.comment.replies.push(replyNote);
		}
	}

	async submit() {
		if (typeof this.onSubmit === 'function') {
			const result = await this.onSubmit({ comment: this.comment });
			if (result) {
				this.comment.update();
			}
		}
		else if (this.comment.isReply()) {
			this.comment.date.created = new Date();
			this.comment.update();
		}
		else if (this.comment.kid) {
			this.comment.date.updated = new Date();
			this.comment.update();
		}
		else {
			const note = new NoteComment({ ...this.commentsCtrl?.tmpContext.notes[0] });
			const nodeNote = this.noteContextCtrl?.NodeService.create('K_NODE;KNOTE');
			nodeNote.addRepre(new Repre({
				value: note.content,
			}));
			nodeNote.addRelation(
				COMPOSED_OF,
				this.noteContextCtrl?.NodeService.create(
					'K_NODE;KNOTECTX',
					this.noteContextCtrl?.ctx?.kid,
				),
			);

			nodeNote.addRelation(
				COMPOSED_OF,
				this.noteContextCtrl?.NodeService.create(
					'K_NODE;KNOTETYPE',
					note.type,
				),
			);

			note.date.created = new Date();
			if (!note.kid && this.commentsCtrl) {
				// await this.notesCtrl.createNote(note);
			}

			// on simule un kid (pour l'instant)
			note.kid = this.User.getRef();
			this.parent?.comment.replies.push(note);
			this.commentsCtrl?.reset();
		}
	}
}
